import React, { useState } from "react";
import ButtonPrimary from "components/Button/ButtonPrimary";
import Input from "components/Input/Input";
import Label from "components/Label/Label";
import Textarea from "components/Textarea/Textarea";
import Heading2 from "components/Heading/Heading2";
import CurvedContainer from "../../../components/CurvedContainer";
import "../../../styles/styles.css";
import axios from "axios";

const info = [
  {
    title: "💌 COURRIEL",
    desc: <a href="mailto:g_bataille@hotmail.com"><u>g_bataille@hotmail.com</u></a>,
  },
  {
    title: "☎ TÉLÉPHONE",
    desc: <a href="tel:+438-494-7787">438-494-7787</a>,
  },
];

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageContact = () => {
  const [errors, setErrors] = useState({} as any);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const newErrors: any = [];

    if (name == "") {
      newErrors.name = "Le nom d'utilisateur est requis.";
    }
    if (email == "") {
      newErrors.email = "L'adresse email est requise.";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.email = "L'adresse email est invalide.";
    }
    if (message == "") {
      newErrors.message = "Le message est requis.";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      try {
        const form = new FormData();
        form.append('name', name);
        form.append('email', email);
        form.append('message', message);
        const response = await axiosInstance.post("api/mail", form);
        console.log("Form data submitted successfully:", response.data);
        alert("Message envoyé avec succès!");
        //window.location.href = window.location.origin;
      } catch (error) {
        console.error("Erreur d'envoi du message:", error);
      }
    }
  };

  return (
    <CurvedContainer>
      <div>
        <header className="text-center max-w-2xl mx-auto sm:mb-16 lg:mb-8">
          <Heading2 style={{ color: "black" }} className="center inline-block align-middle text-4xl font-semibold md:text-5xl">
            Contact
          </Heading2>
          <span style={{ color: "black", fontSize: "20px" }} className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
            Laissez un message et je vous recontacterai.
          </span>
        </header>

        <div style={{ color: "black", fontSize: "20px" }} className="grid gap-8 lg:grid-cols-3">
          <div style={{ paddingLeft: "50px" }} className="max-w-sm space-y-6">
            {info.map((item, index) => (
              <div key={index}>
                <h3 style={{ color: "black", fontSize: "20px" }} className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                  {item.title}
                </h3>
                <span style={{ color: "black", fontSize: "20px" }} className="block mt-2 text-neutral-500 dark:text-neutral-400">
                  {item.desc}
                </span>
              </div>
            ))}
          </div>
          <div className="border border-neutral-100 dark:border-neutral-700 lg:hidden"></div>

          <div className="p-5 w-full sm:w-[500px] mx-auto rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg">
            <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-3 w-full" method="POST">
              <label className="block">
                <Label><div style={{ color: "black", fontSize: "20px" }}>Nom</div></Label>
                <Input
                  style={{ backgroundColor: "white", fontSize: "20px" }}
                  placeholder=""
                  type="text"
                  className="mt-1 w-full"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </label>
              {errors.name && (
                <span style={{ color: "red", marginLeft: "5px", fontSize: "20px" }}>{errors.name}</span>
              )}

              <label className="block">
                <Label><div style={{ color: "black", fontSize: "20px" }}>Courriel</div></Label>
                <Input
                  style={{ backgroundColor: "white", fontSize: "20px" }}
                  type="email"
                  placeholder="exemple@exemple.com"
                  className="mt-1 w-full"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
              {errors.email && (
                <span style={{ color: "red", marginLeft: "5px", fontSize: "20px" }}>{errors.email}</span>
              )}

              <label className="block">
                <Label><div style={{ color: "black", fontSize: "20px" }}>Message</div></Label>
                <Textarea
                  style={{ backgroundColor: "white", fontSize: "20px" }}
                  className="mt-1 w-full"
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </label>
              {errors.message && (
                <span style={{ color: "red", marginLeft: "5px", fontSize: "20px" }}>{errors.message}</span>
              )}

              <ButtonPrimary type="submit">Envoyer</ButtonPrimary>
            </form>

            {response && <p style={{ fontSize: "20px" }}>{response}</p>}
          </div>
        </div>
        <br /><br />
      </div>
    </CurvedContainer>
  );
};

export default PageContact;
